module.exports = __webpack_public_path__ + "img/Rust-Inspect-Large.3627e4c9.png";